import { capabilityState } from "./capabilityState";

/**
 * The agents "Criar agentes" will write, in the order a client meets them: the
 * union of what each enabled agent capability writes (the setup gives each
 * skill's `agents`). With a roteiro read, its specialists take the triage's
 * place, one per area, like applying does.
 */

const FLOW_ORDER = ["agent_recepcao", "agent_qualificador", "agent_processos", "agent_closer", "agent_contratos"];

/**
 * @param {object[]} skills    setup skills
 * @param {Record<string, boolean>} enabled
 * @param {object|null} plan   the roteiro's plan, when already read
 * @returns {{id: string, name: string, does: string}[]}
 */
export function agentsToCreate(skills, enabled, plan = null) {
  const byId = new Map();
  for (const s of skills || []) {
    if (s.kind !== "agent" || !enabled?.[s.id]) continue;
    const { state } = capabilityState(s);
    if (state !== "ready" && state !== "waiting") continue;
    for (const a of s.agents || []) if (!byId.has(a.id)) byId.set(a.id, a);
  }
  const rank = (id) => (FLOW_ORDER.includes(id) ? FLOW_ORDER.indexOf(id) : FLOW_ORDER.length);
  const ordered = [...byId.values()].sort((a, b) => rank(a.id) - rank(b.id));

  const specialists = plan?.specialists || [];
  if (!specialists.length) return ordered;
  return ordered.flatMap((a) =>
    a.id === "agent_qualificador"
      ? specialists.map((s, i) => ({ id: `agent_triagem_${i + 1}`, name: s.name, does: s.focus || "Triagem do caso" }))
      : [a],
  );
}
